import { RefreshCw } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';

interface PlayersPageStaleBannerProps {
  onRefresh: () => void;
}

/**
 * Story 050 — passive "updates available" affordance for the director's
 * PlayersPage. Renders only when the controller flags the list as stale;
 * the director clicks Refresh at a convenient time. The list itself does
 * not mutate while the banner is up — that's the whole point.
 */
export function PlayersPageStaleBanner({ onRefresh }: PlayersPageStaleBannerProps) {
  const { t } = useTranslation('director');
  return (
    <div
      data-testid="players-stale-banner"
      className="mb-4 flex items-center justify-between gap-3 rounded border border-amber-300 bg-amber-50 px-3 py-2 text-sm text-amber-900"
    >
      <span>{t('players_page.stale_banner_message')}</span>
      <Button
        variant="outline"
        size="sm"
        data-testid="players-stale-banner-refresh"
        className="shrink-0 gap-1 border-amber-300 text-amber-900 hover:bg-amber-100"
        onClick={onRefresh}
      >
        <RefreshCw className="h-3 w-3" />
        {t('players_page.stale_banner_refresh')}
      </Button>
    </div>
  );
}
